import React from 'react';
import './RolesTab.css';
import CreateRole from '../CreateRole/CreateRole';
import {createPortal} from 'react-dom';
import UniversalTable from '../UniversalTable/UniversalTable';
import {sendUpdateRoleStatus} from '../../api/rolesApi';

const RolesTab = ({
  handleContextMenu,
  dataList,
  selectedItems,
  selectedItemId,
  checkIsAuthenticated,
  activePopup,
  handleSelectedPopup,
  updateTabData,
  selectedTab,
  menuTarget,
  typeAction,
  handleTypeActionClear,
  onSelectItem,
}) => {
  // Определяем колонки таблицы
  const columns = [
    {key: 'number', title: '№'},
    {key: 'name', title: 'Наименование'},
    {key: 'is_system', title: 'Системный'},
    {
      key: 'status',
      title: 'Статус',
      type: 'select',
      options: [
        {value: 'active', label: 'Активен'},
        {value: 'archived', label: 'В архиве'},
      ],
      onChange: (options, roleId) => {
        updateStatusRole(options.value, roleId);
      },
    },
  ];

  const updateStatusRole = (status, roleId) => {
    sendUpdateRoleStatus({
      data: [
        {
          id: roleId,
          status_id: status === 'archived' ? 2 : 1,
        },
      ],
      organisation_id: selectedItemId,
    })
      .then(() => {
        updateTabData(selectedTab);
      })
      .catch((err) => {
        console.error('Ошибка при удалении:', err);
      });
  };
  console.log(menuTarget);
  // Формируем dataRowElement, если menuTarget существует

  // Данные для таблицы (если dataList пуст, используем массив с пустым объектом)
  const data = dataList || [{}];

  // Определяем данные для попапа в зависимости от typeAction
  const popupData =
    typeAction === 'edit' || typeAction === 'duplicate'
      ? menuTarget
      : undefined;
  return (
    <div className='roles-container'>
      <div className='roles__table'>
        {/* Таблица с данными */}
        <UniversalTable
          data={data}
          columns={columns}
          handleContextMenu={handleContextMenu}
          selectedItems={selectedItems}
          onRowClick={() => {}}
          onSelectItem={onSelectItem}
          expandedRow={null}
        />
      </div>

      {/* Попап CreateRole, отрендеренный через createPortal */}
      {createPortal(
        <CreateRole
          typeAction={typeAction}
          selectedItemId={selectedItemId}
          checkIsAuthenticated={checkIsAuthenticated}
          activePopup={activePopup}
          handleSelectedPopup={handleSelectedPopup}
          updateTabData={updateTabData}
          selectedTab={selectedTab}
          data={popupData}
          handleTypeActionClear={handleTypeActionClear}
        />,
        document.body
      )}
    </div>
  );
};

export default RolesTab;
